module.exports = __webpack_public_path__ + "static/img/iOS_qrCode.3c4755a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/download/iOS_qrCode.png
// module id = bn8I
// module chunks = 23